import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=66a10e31&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"
import style0 from "@/styles/_information.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Information.vue?vue&type=style&index=1&id=66a10e31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a10e31",
  null
  
)

export default component.exports